module.exports = __webpack_public_path__ + "static/img/certify02.d45a718.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/swiper/images/certify02.png
// module id = 3Fop
// module chunks = 1